"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const isObject_1 = __importDefault(require("lodash/isObject"));
function getFixedPrecisionInSeconds(metric) {
    if (metric) {
        return +(metric / 1000).toFixed(3);
    }
    return metric;
}
function getTimeSinceNavStart(metric, startTime) {
    if (metric) {
        return getFixedPrecisionInSeconds(metric - startTime);
    }
    return metric;
}
function getFirstPaintTime(performance) {
    if (window.PerformancePaintTiming) {
        const paintMetrics = performance.getEntriesByType('paint');
        if ((0, isArray_1.default)(paintMetrics) && paintMetrics.length > 0) {
            return getFixedPrecisionInSeconds(paintMetrics[0].startTime);
        }
    }
    return undefined;
}
function getPerformanceNavigationTimingMetrics(performance) {
    const navigationTimingMetrics = performance.getEntriesByType('navigation');
    if ((0, isArray_1.default)(navigationTimingMetrics) && navigationTimingMetrics.length > 0) {
        const timing = navigationTimingMetrics[0];
        return {
            us: getFixedPrecisionInSeconds(timing.unloadEventStart),
            ue: getFixedPrecisionInSeconds(timing.unloadEventEnd),
            rds: getFixedPrecisionInSeconds(timing.redirectStart),
            rde: getFixedPrecisionInSeconds(timing.redirectEnd),
            rdc: (0, get_1.default)(timing, 'redirectCount'),
            fs: getFixedPrecisionInSeconds(timing.fetchStart),
            dls: getFixedPrecisionInSeconds(timing.domainLookupStart),
            dle: getFixedPrecisionInSeconds(timing.domainLookupEnd),
            cs: getFixedPrecisionInSeconds(timing.connectStart),
            scs: getFixedPrecisionInSeconds(timing.secureConnectionStart),
            ce: getFixedPrecisionInSeconds(timing.connectEnd),
            reqs: getFixedPrecisionInSeconds(timing.requestStart),
            ress: getFixedPrecisionInSeconds(timing.responseStart),
            rese: getFixedPrecisionInSeconds(timing.responseEnd),
            dl: getFixedPrecisionInSeconds(timing.domLoading),
            fp: getFirstPaintTime(performance),
            di: getFixedPrecisionInSeconds(timing.domInteractive),
            dcls: getFixedPrecisionInSeconds(timing.domContentLoadedEventStart),
            dcle: getFixedPrecisionInSeconds(timing.domContentLoadedEventEnd),
            dc: getFixedPrecisionInSeconds(timing.domComplete),
            les: getFixedPrecisionInSeconds(timing.loadEventStart),
            lee: getFixedPrecisionInSeconds(timing.loadEventEnd),
        };
    }
    return null;
}
function getLegacyPerformanceTimingMetrics(performance) {
    const { timing, navigation } = performance;
    if ((0, isObject_1.default)(timing)) {
        const startTime = timing.navigationStart;
        return {
            us: getTimeSinceNavStart(timing.unloadEventStart, startTime),
            ue: getTimeSinceNavStart(timing.unloadEventEnd, startTime),
            rds: getTimeSinceNavStart(timing.redirectStart, startTime),
            rde: getTimeSinceNavStart(timing.redirectEnd, startTime),
            rdc: (0, get_1.default)(navigation, 'redirectCount'),
            fs: getTimeSinceNavStart(timing.fetchStart, startTime),
            dls: getTimeSinceNavStart(timing.domainLookupStart, startTime),
            dle: getTimeSinceNavStart(timing.domainLookupEnd, startTime),
            cs: getTimeSinceNavStart(timing.connectStart, startTime),
            scs: getTimeSinceNavStart(timing.secureConnectionStart, startTime),
            ce: getTimeSinceNavStart(timing.connectEnd, startTime),
            reqs: getTimeSinceNavStart(timing.requestStart, startTime),
            ress: getTimeSinceNavStart(timing.responseStart, startTime),
            rese: getTimeSinceNavStart(timing.responseEnd, startTime),
            dl: getTimeSinceNavStart(timing.domLoading, startTime),
            fp: getFirstPaintTime(performance),
            di: getTimeSinceNavStart(timing.domInteractive, startTime),
            dcls: getTimeSinceNavStart(timing.domContentLoadedEventStart, startTime),
            dcle: getTimeSinceNavStart(timing.domContentLoadedEventEnd, startTime),
            dc: getTimeSinceNavStart(timing.domComplete, startTime),
            les: getTimeSinceNavStart(timing.loadEventStart, startTime),
            lee: getTimeSinceNavStart(timing.loadEventEnd, startTime),
        };
    }
    return null;
}
function getTiming() {
    const performance = window.performance ||
        window.webkitPerformance ||
        window.msPerformance ||
        window.mozPerformance;
    if (performance) {
        if (window.PerformanceNavigationTiming) {
            return getPerformanceNavigationTimingMetrics(performance);
        }
        return getLegacyPerformanceTimingMetrics(performance);
    }
    return null;
}
exports.default = getTiming;
